import { Droppable } from "react-beautiful-dnd";

import ItemDraggable from "./ItemDraggable.js";

export default function ItemSelectionDroppable (props)
{
    const itemId = props.itemStruct.selectionIds[props.num];
    const itemDraggables = itemId === null ? (<></>) : (<ItemDraggable key={itemId} index={0} itemId={itemId}/>);

    const droppableId = "itemSelection" + props.num;

    const placeholders = {
	info: "Information",
	bp: "Conseil",
	indice: "Indice"
    };
    
    const placeholder = placeholders[props.itemStruct.type] + (props.itemStruct.type === "bp" ? "" : " " + (props.num+1));    
    
    return (
	<Droppable droppableId={droppableId}>
	    {(provided, snapshot) => {
		const borderColor = "border-secondary-subtle ";
		const bgColor = snapshot.isDraggingOver ? "bg-secondary-subtle " : "bg-white ";
		return (
		    <div className={"position-relative border border-2 rounded p-2 " + bgColor + borderColor}
			 style={{ height: "62px", width: "380px" }}
			 ref={provided.innerRef} { ...provided.droppableProps }
		    >
			<div className="position-absolute start-50 top-50 translate-middle text-secondary text-uppercase">{placeholder}</div>
			{itemDraggables}
			{provided.placeholder}
		    </div>
		);
	    }}
	</Droppable>
    );
}
